import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TokenStorage } from 'src/app/core/token-storage';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
import { AlertComponent } from '../message/alert/alert.component';
import { MatDialog } from '@angular/material/dialog';
import { ThemeService } from 'src/app/service/theme.service';
import { MessagePopupComponent } from '../message/message-popup/message-popup.component';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    standalone: false
})
export class MenuComponent implements OnInit {
  @ViewChild('menuInput', { static: false })
  menuInput!: ElementRef<HTMLInputElement>;
  searchText: string = '';
  objectLogo: any;
  searchOption = '';
  getSearchOption!: any[];
  getmenu: any;
  likedislikes: any;
  isSearch = false;
  isMenu: boolean = false;
  isMenucompangin: boolean = false;
  sidenav!: MatSidenav;
  events: string[] = [];
  mediaSub!: Subscription;
  deviceXs: boolean = false
  userDetails: any = '';
  createMenu: any[] = [];
  viewMenu: any[] = [];
  menuArray: any[] = [];
  firstName: any;
  storagecontainer: any;
  storageAccessToken: any;
  profileImg: string = '';
  objectTypeID: any;
  logoUrl!: string;
  apicallMade: boolean=false;
  constructor(public mediaObserver: MediaObserver, private token: TokenStorage, 
    private router: Router, public restService: RestService, private themeService: ThemeService,
    private loader: LoaderService, private dialog: MatDialog, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    //this.getOrgTheme();
    setTimeout(()=>{
      this.themeService.getLogo().subscribe((data:any)=>{
        this.logoUrl=data;
      });
    },1000)
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Set isSearch to false
        this.isSearch = false;
        
      }
    });
    if (this.isMenucompangin == false && this.token.get()) {
      this.getSmileyIcons();
     if(!this.apicallMade){
      // this.getmenus();
      this.apicallMade=true;
     }
    }
    this.isMenu = window.location.pathname.includes('login') ? false : true;

    this.isMenucompangin = false;//window.location.pathname.includes('campaign') ? true : false;
    if (window.location.pathname.includes('campaign')) {
      this.isMenucompangin = true;
    }
    if (window.location.pathname.includes('profile-approval')) {
      this.isMenucompangin = true;
    }

    this.mediaSub = this.mediaObserver.asObservable()
      .subscribe((change) => {
        change.forEach((item) => {

          if (item.mqAlias === 'xs') {
            this.deviceXs = true;
          }
        });
      });
  }

  Search() {

    setTimeout(() => {
      if (this.menuInput) {
        this.menuInput.nativeElement.focus();
      }
    }, 100);

    this.isSearch = !this.isSearch
    this.searchOption = ''
    this.searchText = 'Type to Search'
    // this.objectTypeID = this.permissionService.getObjectTypeID();
    // if (this.objectTypeID == 101) {
    //   this.searchText = 'Search Challenge'
    // } else if (this.objectTypeID == 102) {
    //   this.searchText = 'Search Idea'
    // } else if (this.objectTypeID == 103) {
    //   this.searchText = 'Search Risk'
    // } else if (this.objectTypeID == 104) {
    //   this.searchText = 'Search Site visit'
    // } else if (this.objectTypeID == 105) {
    //   this.searchText = 'Search Workshop'
    // } else if (this.objectTypeID == 106) {
    //   this.searchText = 'Search Project'
    // } else if (this.objectTypeID == 107) {
    //   this.searchText = 'Search Q&A'
    // } else if (this.objectTypeID == 108) {
    //   this.searchText = 'Search Request'
    // } else if (this.objectTypeID == null) {
    //   this.searchText = 'Type to Search'
    // }
  }
  logout() {
    const dialogRef = this.dialog.open(MessagePopupComponent, {
      width: '35vw',
      data: { data: 'Are you sure you want to log out?', type: 'alert' }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        window.localStorage.clear();
        this.router.navigate(['/start-meeting']);
        setInterval(function () {
          window.location.reload();
        }, 200);
      }
    });

  }

  setObjectDynamic(menu: any, url: string) {
    this.loader.show();
    if (menu.isEnabled === true) {
      window.localStorage.setItem('menusinglelogo', menu.iconClass.toString()); //classOfObject
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate([url]);
    } else {
      this.router.navigate(['/coming-soon']);
    }
    this.loader.hide();
  }
  navigateToMenulist(id: any) {
    this.router.navigate(['menulist/' + id]);

  }
  organizationclick() {
    this.router.navigate(['/menulist']);
  }
  awaitingPage() {
    this.router.navigate(['/awaitingModeration']);
  }
  getmenus() {
    // if(localStorage.getItem('menuData')){
    // let menu:any=localStorage.getItem('menuData')||[];
    // this.getmenu=JSON.parse(menu);
    // this.createMenu = this.getmenu.filter((item: any) => item.isChecked != 0 && item.isQuickCreate == true );
    // let viewMenu = this.getmenu.filter((item: any) => item.isChecked != 0 && item.isModule == true );
    // this.viewMenu=viewMenu.filter((m:any)=>m.isHighlightMenu===false);
    // }
   

  }
  getSearchOptions() {
    let params = {
      "searchText": this.searchOption,
      "objectTypeID": this.objectTypeID
    }
   
  }
  search() {
    if (this.searchOption.length > 2) {
      this.getSearchOptions();
    }
  }
  viewPage(objectID: number, objectTypeId: number) {
    this.loader.show();
    let params = {
      "objectID": objectID,
      "objectActionTypeID": 601,
      "smileyReactionID": null,
      "isFollowing": false,
      "commentID": null
    }

    this.router.navigate(['/view/' + objectTypeId + '/' + objectID]);
    this.searchOption = ''
    this.isSearch = false;
    this.getSearchOption = [];
  }
  // getSmileyIcons() {
  //   this.restService.postData(null, '/api/v1/iy/MSTObject/GetAllSmileyReactions').subscribe((data: any) => {
  //     if (data.rcode == 200) {
  //       // window.localStorage.setItem('smilerxns',JSON.stringify(data.rObj.getAllSmileyReactions))
  //       this.permissionService.setSmileRxns(data.rObj);
  //       let profileImg = data.rObj.loginUserID;
  //       this.profileImg = `${data.rObj.storagecontainer}/${profileImg.toUpperCase()}_tn.jpg`
  //     }
  //   }, (err: any) => {
  //     this.router.navigate(['/start-meeting']);
  //   });
  // }
  getSmileyIcons() {
    // this.restService.postData(null, '/api/v1/iy/TRNObject/GetHomePage').subscribe((data: any) => {
    //   if (data.rcode == 200) {
    //     // window.localStorage.setItem('smilerxns',JSON.stringify(data.rObj.getAllSmileyReactions))
    //     this.permissionService.setSmileRxns(data.rObj);
    //     let profileImg = data.rObj.loginUserID;
    //     this.profileImg = `${data.rObj.storagecontainer}/${profileImg}_tn.jpg`
    //   }
    // }, (err: any) => {
    //   this.router.navigate(['/start-meeting']);
    // });
  }
  getOrgTheme() {
    // this.restService.postData(null, '/api/digital/core/Organization/GetOrgAppTheme', null, 'LoginUrl').subscribe((data: any) => {
      let data = {
        "rcode": 200,
        "rObj": {
            "orgAppTheme": "{\"iconColor\":\"#7f2165\",\"headerColor\":\"#7f2165\",\"buttonColor\":\"#7c1e60\",\"secondaryColor\":\"#f15e55\",\"logoURL\":\"./assets/images/GDAConnct1.png\",\"dsbBackgroundURL\":\"./assets/images/newones.png\",\"dsbOverlayURL\":\"../../../assets/images/bglayout.png\",\"loginBackgroundURL\":\"https://01i327.n3cdn1.secureserver.net/wp-content/uploads/2022/06/scott-graham-5fNmWej4tAA-unsplash.jpg?time=1673988798\",\"favIcon\":\"./assets/images/favicon_GDA.png\",\"appTitle\":\"i3 Digital Connect\"}"
        },
        "isSuccess": false,
        "rmsg": [
            {
                "errorText": "SUCCESS",
                "errorCode": "SUCCESS",
                "fieldName": null,
                "fieldValue": null
            }
        ],
        "reqID": "f0926773-0ba2-47ab-968f-695334299631",
        "trnID": null
    }
      if (data.rcode == 200) {
        // this.loader.hide();
        let theme = JSON.parse(data.rObj.orgAppTheme);
        this.themeService.setLogo(theme?.logoURL);
        this.logoUrl = theme?.logoURL;
        setTimeout(() => {
          this.themeService.setBg(theme?.dsbBackgroundURL);
        }, 2000);
        // this.router.navigate(['/start-meeting']);
      } else if (data.rcode == 501) {
        // this.loader.hide();
        const dialogRef = this.dialog.open(AlertComponent, {
          width: '35vw',
          data: { data: data.rmsg[0]?.errorText, type: 'alert' }
        });
        dialogRef.afterClosed().subscribe();
      }
      else {
        // this.loader.hide();
        const dialogRef = this.dialog.open(AlertComponent, {
          width: '35vw',
          data: { data: data.rmsg[0]?.errorText, type: 'alert' }
        });
        dialogRef.afterClosed().subscribe();
      }
    // })
  }

  handleImageError(profileImg:string) {
    profileImg = '../../../assets/images/user-icon.png';
  }
}
